import { FormField, HTMLInputProps, Input, Textarea } from '@cian/ui-kit';
import { FC } from 'react';

import { TFormErrors, TFormValues } from '../../types';
import { FormWrapper } from '../FormWrapper';
import { NBSP } from '../../../../constants/symbols';
import { FormError } from '../FormError';

import styles from './styles.css';

interface IConsultationForm extends HTMLInputProps {
  handleInputChange: <T extends keyof TFormValues>(inputName: T, value: TFormValues[T]) => void;
  values: TFormValues;
  errors?: TFormErrors | null;
}

export const EmailConsultationRequest: FC<IConsultationForm> = ({ handleInputChange, errors, values }) => {
  return (
    <FormWrapper title={`Оставьте заявку — свяжемся с${NBSP}вами по${NBSP}почте`}>
      <div className={styles['consultation-form-email']}>
        <FormField label="Ваш еmail" errorMessage={errors?.email} required withoutMargin>
          <Input
            value={values.email}
            size="M"
            onChange={(_, value) => handleInputChange('email', value)}
            data-testid="leave-contacts-modal-email-input"
          />
        </FormField>
        <FormField label="Что хотите узнать?" errorMessage={errors?.question} required withoutMargin>
          <Textarea
            value={values.question}
            onChange={(_, value) => handleInputChange('question', value)}
            data-testid="leave-contacts-modal-question-input"
            minRows={4}
          />
        </FormField>
      </div>
      {!!errors?.root && <FormError>{errors.root}</FormError>}
    </FormWrapper>
  );
};
